/**
 * Web entry point.
 *
 * On Android/iOS Metro starts from `index.js`; webpack (see web/webpack.config.js)
 * starts from this file and renders the app with react-native-web + react-dom.
 *
 * @format
 */

import 'react-native-gesture-handler';

import { AppRegistry } from 'react-native';
import appJson from './app.json';
import App from './App';
import { registerServiceWorker } from './src/utils/registerServiceWorker.web';
import { setRTLTextPlugin, setWorkerUrl } from 'maplibre-gl';
import './assets/fonts/index.css';
import 'maplibre-gl/dist/maplibre-gl.css';

// maplibre-gl normally picks its worker script at runtime with
// `new URL('./maplibre-gl-worker.mjs', import.meta.url)`. webpack compiles
// `import.meta.url` to a build-machine `file://` path (see web/webpack.config.js),
// so that fallback produces an empty URL and the browser resolves
// `new Worker('')` to the page itself (`http://localhost:8081/`), which returns
// index.html and is blocked with "disallowed MIME type ('text/html')". Point the
// worker URL at the copy EmitMaplibreWorkerPlugin places under `/static/js/`
// next to the JS chunks; it resolves `./maplibre-gl-shared.mjs` relative to
// itself, so both files must sit in the same directory.
setWorkerUrl('/static/js/maplibre-gl-worker.mjs');

// maplibre-gl does not join Arabic-script letters (Persian labels) on its own;
// the RTL text plugin shapes them (ICU/HarfBuzz in WASM). Load it eagerly so
// the first map paint already renders joined text. The URL points at the copy
// EmitRtlTextPlugin places under `/static/js/` next to the JS chunks; the file
// is self-contained (WASM embedded), so no further asset is fetched.
setRTLTextPlugin('/static/js/mapbox-gl-rtl-text.js', false).catch(error => {
  console.warn('Failed to load the MapLibre RTL text plugin:', error);
});

AppRegistry.registerComponent(appJson.name, () => App);

const documentRef = (
  globalThis as { document?: { getElementById(id: string): unknown | null } }
).document;

const rootTag = documentRef?.getElementById('root');

AppRegistry.runApplication(appJson.name, {
  rootTag: rootTag as Parameters<
    typeof AppRegistry.runApplication
  >[1]['rootTag'],
});

// Cache the app shell for offline use. No-op in development (`__DEV__`).
registerServiceWorker();
